import CompanyLogo from "../../../components/CompanyLogo/CompanyLogo";
import "./CompaniesCarousel.css";
import "./Companies.css";
import {useEffect, useRef, useState} from "react";

const Companies = ({activeCompanies}) => {
    const COMPANIES = ["Sancor", "RUS", "Zurich", "Terrawind", "Federacion_Patronal", "Experta"];
    const filteredCompanies = COMPANIES.filter(company => activeCompanies.includes(company));
    const [loop, setLoop] = useState(false);
    const carouselRef = useRef(null);
    const carouselContainerRef = useRef(null)

    const updateCarousel = () => {
        const carousel = carouselRef.current;
        const carouselContainer = carouselContainerRef.current;
        const slides = carousel?.querySelectorAll(".CompaniesCarousel__slide");
        const slidesArr = Array.from(slides);
        const totalWidth = slidesArr.reduce((sum, slide) => sum + slide.offsetWidth, 0);
        const carouselContainerWidth = carouselContainer.offsetWidth;

        setLoop(totalWidth > carouselContainerWidth);
    };

    useEffect(() => {
        updateCarousel();
        window.addEventListener("resize", updateCarousel);
        return () => {
            window.removeEventListener("resize", updateCarousel);
        };
    }, [filteredCompanies]);

    return (
        <div className="Companies__container" ref={carouselContainerRef}>
            <div className={`CompaniesCarousel ${loop ? "--animated" : "--centered"}`}
                 ref={carouselRef}
                 style={{
                     '--CC-animation-duration': filteredCompanies.length <= 3 ? "9s" : "15s",
                     '--CC-slides': filteredCompanies.length
                 }}>
                {filteredCompanies.map((company, idx) => (
                    <div className={`CompaniesCarousel__slide ${loop ? "--animated" : "--centered"}`}
                         key={idx}
                         style={{
                             animationDelay: `calc(var(--CC-animation-duration) / ${filteredCompanies.length} * (${filteredCompanies.length} - ${idx}) * -1)`,
                         }}>
                        <div className="CompaniesCarousel__logo">
                            <CompanyLogo key={idx} company={company}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Companies;